module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='			<div class="info-header">\n				<div class="info-header__title">System status</div>\n			</div>\n\n			<ul class="m-sidebar-list">\n				<li class="m-sidebar-list__item">\n					<div class="list-item__inner">\n						<div class="list-item__row">\n							<span class="">Platform</span>\n							<span class="align-right"><span class="m-status-indicator has-sign is-positive">online</span></span>\n						</div>\n					</div>\n				</li>\n\n				';
 if (parseInt(getAttribute('status.devices.error')) > 0) { 
__p+='\n				<li class="m-sidebar-list__item is-warning js-warning-click">\n					<div class="list-item__inner">\n						<div class="list-item__label">Warning</div>\n						<div class="list-item__row"><a href="/#devices?state=error">'+
((__t=( getAttribute('status.devices.error') ))==null?'':__t)+
' Nodes report problems</a></div>\n					</div>\n				</li>\n				';
 } 
__p+='\n\n				<li class="m-sidebar-list__item">\n					<div class="list-item__inner">\n						<div class="list-item__row">\n							<span class="">Connected devices</span>\n							<span class="align-right">'+
((__t=( getAttribute('status.devices.online') ))==null?'':__t)+
'</span>\n						</div>\n						<div class="list-item__row">\n							<div class="m-progress">\n								<div class="m-progress__indicator" style="width:'+
((__t=( getConnectedPercent() ))==null?'':__t)+
'%;"></div>\n							</div>\n						</div>\n					</div>\n				</li>\n\n			</ul>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/page-status/show/templates/system.html
// module id = 460
// module chunks = 0